// extracted by mini-css-extract-plugin
export default {"loaderContainer":"Loader_loaderContainer__UDDYf","loader":"Loader_loader__+lRPl","spin":"Loader_spin__E4RJ0","small":"Loader_small__gii2m"};